<script setup lang="ts">
interface VerticalSparatorProps {
    height?: string;
}
withDefaults(defineProps<VerticalSparatorProps>(), {
    height: "100%",
});
</script>
<template>
    <div class="vertical-separator" :style="{ height }"></div>
</template>
<style scoped lang="scss">
.vertical-separator {
    width: 1px;
    background-color: $bg-soft-200;
}
</style>
